import * as React from "react"
import type { SVGProps } from "react"
const SvgImageGallery = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M2.36 4.91a2 2 0 0 0-.32 1.5l1.52 8.61a1 1 0 0 0 .4.66 1 1 0 0 0 .75.17q.42-.08.65-.42.22-.34.15-.76l-1.5-8.6 10.82-1.92.17.75q.13.5.47.69t.7.14.66-.35.15-.8l-.18-.78a2.2 2.2 0 0 0-.85-1.28 1.8 1.8 0 0 0-1.45-.34L3.66 4.1q-.82.15-1.3.81m7.98 13.9h8.33a.4.4 0 0 0 .38-.23.4.4 0 0 0-.05-.43l-2.29-3.06a.4.4 0 0 0-.33-.17.4.4 0 0 0-.33.17l-2.17 2.89-1.54-2.06a.4.4 0 0 0-.33-.17.4.4 0 0 0-.33.17L10 18.15a.4.4 0 0 0-.04.43.4.4 0 0 0 .37.23Zm1.25-5.83q.52 0 .89-.36c.37-.36.36-.54.36-.89s-.12-.64-.36-.88a1.2 1.2 0 0 0-.89-.36q-.51 0-.88.36a1.2 1.2 0 0 0-.37.88q0 .53.37.89c.37.36.53.36.88.36" />
    <path
      fillRule="evenodd"
      d="M7.6 7.73Q7 8.3 7 9.13v11.04q0 .82.6 1.4.6.57 1.43.57H20q.82 0 1.41-.59.6-.59.59-1.4v-11q0-.83-.59-1.41A2 2 0 0 0 20 7.15H9.03q-.82 0-1.42.57M20 20.13V9.15H9v11z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgImageGallery
